// 英语

export const main = {
  KubuqiOfficialWebsite: 'Kubuqi Award',
  // 导航信息
  homePage: 'Home',
  backgroundOfTheCompetition: 'Background',
  latestNews: 'Latest News',
  previousCompetition: 'Previous Event',
  firstCompetition: 'The first Kubuqi Competition',
  previousCompetitionTwo: 'Second Event',
  firstCompetitionTwo: 'The Second Kubuqi Competition',
  secondCompetition: 'Online Public Voting',
  secondBackText:
    "The top 15 finalists of the 'Speak Sustainability' Secondary School Short Video Contest have been selected! It's now up to you to vote for your favorite video, your vote accounts for 20% of the final results!",
  active: 'Talk about Sustainability Short Film Voting',
  pastGames: 'Past Award',
  topUniversity: 'University Group Winners List',
  commonProblem: 'FAQ',
  aboutUs: 'About Us',
  findUs: 'Contact Us',
  loginAndRegistration1: 'Sign in/Sign up',
  loginAndRegistration: 'Sign in',
  // 底部信息
  filingNumber: 'Filing number',
  YiliPublicWelfareFoundation: 'Elion Foundation',
  contactAddress: 'Address',
  contactAddressDetaile:
    'Room 6005, 60/F, Central Plaza, 18 Harbour Road, Wanchai, Hong Kong',
  notice_info:
    'The organizer reserves the right to amend, modify or cancel the rules and results of the event without prior notice.',
  contactUs: 'Contact Us',
  phone: 'Tel',
  mailbox: 'Email',
  socialMedia: 'Social media',
  // 首页
  competitionSchedule: 'Competition schedule',
  seeMore: 'Learn more',
  previousCompetitions: 'Winners of the First Kubuqi Award',
  introductionToTheOrganizer: 'Organizer',
  introductionToTheOrganizerDetail:
    'Yili Public Welfare Fund is a charitable organization initiated by Yili International Investment Co., Ltd., focusing on environmental protection. The foundation is committed to promoting the development of new technologies and new models in international and domestic ecological governance and environmental protection, especially in the environmental governance and sustainable development of the "the Belt and Road" countries.',
  workName: 'Entry Title',
  and: 'and',
  WinningTeam: 'Team',
  Awarded: 'Prize',
  CompetitionName: 'Category',
  OfficialEventManagementPartner: 'Official Event Management Partner',
  OfficialAdvisoryServicePartner: 'Official Advisory Service Partner',
  OfficialSocialImpactPartner: 'Official Social Impact Partner',
  OfficialMentorshipPartner: 'Official Mentorship Partner',
  contextDetaile: 'Learn More',
  CompetitionIntroduction: 'Competition introduction',

  // 首页-奖项
  awards: 'Prize & Award',
  associateHongKongGroup: 'University Group',
  universityInternationalGroup1:
    'International Desert Sustainable Development Proposal Competition (International)  ',

  middleSchoolGroup: 'Secondary School Group',
  middleSchoolGroup1: `<p>“Speak Sustainability”</p><p> Secondary School Short Video Contest</p>`,
  universityInternationalGroup: 'University Group',
  // championTeam1: "Champion Team 1",
  championTeam1: 'Champion x 1',
  championTeam11: 'Champion x 1',
  runnerUpTeam1: '2nd Prize x 1',
  runnerUpTeam11: '2nd Prize x 1',
  thirdPlaceTeam1: '3rd Prize x 1',
  thirdPlaceTeam11: '3rd Prize x 1',
  excellentAwardTeam7: 'Merit Award x 12',
  excellentAwardTeam71: 'Merit Award x 7',
  DepartureFormHongKongSAR: 'Departure form Hong Kong SAR',
  bonus: 'bonus',
  HKD: 'HKD',
  certificate: 'certificate',
  // andDesertFieldVisits: "Certificate of Award and Desert Field Investigation",
  andDesertFieldVisits: '& Kubuqi Desert Visit',
  andDesertFieldVisitsHKcollege: 'w. Certificate',
  andDesertFieldVisits1: 'Kubuqi Desert Visit',
  excellentAwardNTeam: 'Excellent Award N Team',
  // mostEnthusiasticParticipation:
  //   "One school that actively participates in the school award (calculated based on the number of participating team members)",
  mostEnthusiasticParticipation: 'Merit Award x 12',
  // mostEnthusiasticParticipation: "Most Active Participation School Award",
  mostEnthusiasticParticipation1: 'Most Active Participation School Award',
  fieldVisit:
    '*Awarded proposals might be potentially adopted and applied into desert control projects in Kubuqi Desert or deserts in other countries.',
  signUpNow: 'Register Now',
  RegistrationDetermined: 'Registration deadline',
  SubmissionDetermined: 'Submission deadline',
  sliderTitle: 'Scan to Experience',
  sliderSubtitle: 'Kubuqi Award AR Scene',
  RightOfInterpretation:
    'Should there be less than 50 final entries submissions in any category of the competition, the Organizers reserve all rights to modify the rules and format of such category or cancel such category.',
  mostActive: 'Most Active Participation School Award',
  mostActiveSchool: 'Carmel Pak U Secondary School',

  //
  supportingEnterprises: 'Supporting Organizations',
  // 库布其大赛报名
  registrationForTheKubuqiCompetition:
    'Registration for the Kubuqi Competition',
  TEAMNAME: 'Team name',
  fullName: 'Full name',
  position: 'position',
  dateOfBirth: 'Date of birth',
  schoolName: 'School name',
  studentID: 'Student ID',
  Email: 'E-mail',
  studentIDCard: 'Student ID card',
  selectGroup: 'Please select the participating group',
  confirmRegistration: 'Confirm registration',
  registrationSuccessful: 'Registration successful!',
  registrationSuccessfulTips:
    'You will receive a confirmation email of successful registration for the competition later',
  pleaseContact: 'If you have any inquiries, please contact',
  viewAuditProgress: 'View audit progress',
  noData: 'There is currently no data available',

  // 最新资讯
  newsInformation: 'Event News & Posts',
  pressRelease: 'Press Release & Media',
  contestAtlas: 'Gallery',
  currentPosition: 'current location',
  informationDetails: 'Information Details',
  issueDetails: 'Problem Details',
  Comment: 'Comment',
  warnInfo6: 'Please enter your content to comment!',
  PleaseEnterContent: 'Please enter content',
  submitComments: 'Submit Comments',
  commentHistory: 'Comment History',
  noComments: 'No Comments',
  warnInfo7: 'Comment successful',
  videoTitle1:
    'The 2nd Kubuqi Award: University Seminar The Education University of Hong Kong: "Global Warming, Climate Change" Environmental, Social and Governance (ESG) Strategy',
  videoTitle2:
    'The Second Kubuqi Award: University Briefing Session - HSUHK: "Sustainable Finance: Environmental Development in Financial Sectors", Explore Green Economy & New Career Paths',

  // 个人中心
  personalCenter: 'Personal Center',
  accountInformation: 'Account Information',
  myRegistration: 'My Registration',
  // contactUs: '联系我们',
  logOut: 'Log Out',

  //个人中心-基本信息
  basicInformation: 'Account information',
  avatar: 'Team icon',
  teamInformation: 'Team Information',
  addMembers: 'Add Members',
  save: 'save',
  teamName: 'Team name',
  delete: 'delete',
  reset: 'reset',
  edit: 'edit',
  modify: 'modify',
  uploadCampusCard: 'Upload student card',
  front: 'front',
  front: 'front',
  opposite: 'back',

  // 个人中心-我的报名
  registeredContest: 'Competition Registration',
  theKubuqiCompetition: 'Competition Registration',
  matchProgress: 'Open for registration',
  registrationStatus: 'Registration status',
  workStatus: 'Work status',
  pendingApproval: 'Pending approval',
  passed: 'Passed',
  fail: 'Fail',
  WorkSubmissionTime: 'Registration period',
  viewDetails: 'Detail',
  currentState: 'Current state',
  goToModifyInformation: 'Go to modify information',
  return: 'return',
  clickToSubmit: 'Click to submit',
  modifyInformation: 'Please go to modify the information!',
  comingToAnEnd: 'Coming to an end',
  copyEmailAddress: 'Copy email address',
  registrationTeam: 'Registration teams',
  competitionBrowsing: 'No. of visit',
  officialEmail: 'Official email of the competition',
  workSubmit: 'Submit work',
  tips:
    'Tip: Please upload attachments to your work. Attachment type: video、PDF、PPT',
  warnInfo:
    'Tip: Please upload your work attachment (video、PDF、PPT), file size should not exceed 2GB.',
  warnInfo1: 'upload failed!',
  checkEntryStatementInfo: 'Please check the entry Statement first.',

  // 个人中心-作品状态
  notFiled: 'not submitted',
  submitted: 'submitted',
  underReview: 'Under review',
  beShortlistedSuccessfully: 'Successfully shortlisted',
  shortlistingFailure: 'Finalization failed',
  clickToUpload: 'Click to upload',
  uploading: 'uploading',
  // cancellation: '取消',
  submitWorks: 'Submit works',
  IAmAgree: 'I have read and agree',
  EntryStatement: 'Entry Statement',
  IntellectualProperty: '1. Intellectual Property',
  IntellectualPropertyInfo:
    'Participants must ensure that their competition entries are original and do not infringe upon the rights of third parties, including intellectual property, confidentiality, or privacy rights. In case of any infringement, participants shall assume all legal responsibilities.',
  KnowledgeSharing: '2. Knowledge Sharing',
  KnowledgeSharingInfo:
    "Participants understand and agree that the intellectual property of competition entries will be used for educational, scientific dissemination, and ecological conservation purposes. Elion Foundation and TREELION Foundation (hereinafter referred to as the 'Organizers') pledge to use these works for non-commercial purposes to promote the concept of sustainable desert development and ecological preservation.",
  LegalResponsibility: '3. Legal Responsibility',
  LegalResponsibilityInfo:
    'The Organizers will make every effort to protect the intellectual property of competition entries but shall not be held legally responsible for possible infringement activities. In case of disputes, resolutions will be in accordance with relevant laws and regulations.',
  CopyrightOwnership: '4. Copyright Ownership',
  CopyrightOwnershipInfo:
    'Upon submission, all competition entries become the sole copyright of the Organizers.',
  CopyrightUsage: '5. Copyright Usage',
  CopyrightUsageInfo1:
    '1. Intellectual Property Rights (IP): Participants hereby agree that the Organizers possess the rights to use the intellectual property (IP) of the competition entries, including but not limited to copying, dissemination, forwarding, displaying, publishing, modifying, and utilizing the works in various ways. The Organizers may use the competition submissions for non-commercial purposes only, including but not limited to promotion, advertising, and any activities related to the competition.',
  CopyrightUsageInfo2:
    "2. Author Attribution Rights: Unless participants request anonymity in a written notice, the Organizers will make every effort to attribute the works to the authors in any usage scenario. In any case, attribution will only include the participant's name and will not include any other personal information. The Organizers will make every effort to protect the participants' privacy.",
  CopyrightUsageInfo3:
    '3. Promotion and Advertising: All participants agree to the Organizers using their names, photos, and presentations for promotional and advertising purposes.',
  CopyrightUsageInfo4:
    '4. Waiver of Rights: Participants explicitly waive any form of economic or other rights related to the competition entries unless otherwise stipulated in writing.',
  AttendanceOnJudgingDay: '6. Attendance on Judging Day',
  AttendanceOnJudgingDayInfo:
    'For the International Desert Sustainable Development Proposal Competition, all participants who successfully enter the finals must attend the final judging day (on-site judging for the Hong Kong Group).',
  PrivacyStatement: '7. Privacy Statement',
  PrivacyStatementInfo:
    "Participants understand and agree that the Organizers collect personal information, including the participant's full name, email address, and contact number, solely for the purpose of verifying participant identity and contacting winners of the competition. The Organizers will destroy the personal information provided by participants within three months after announcing the competition results (except for information posted on social media pages and website of the competition). The Organizers will not transfer personal information to other third parties, except as required by law.",
  AgreementEffectiveness: '8. Agreement Effectiveness',
  AgreementEffectivenessInfo:
    'By submitting competition entries, participants indicate their agreement with all the terms and conditions of this declaration and are bound by them.',
  lastNoticeInfo:
    '* Please note that the Organizers reserve the final decision-making authority regarding the rules and results of this competition and will not provide further notice. If you have any questions about any part of this declaration or require special negotiations, please contact the Organizers to clarify your rights and expectations.',

  // 登录页面
  loginAccount: 'The Kubuqi Award Registration',
  mailbox: 'Email',
  pleaseEnterTheRegistrationEmail: 'Please enter the registration email',
  password: 'Password',
  pleaseEnterYourLoginPassword: 'Please enter your login password',
  code: 'Verification code',
  pleaseEnterTheVerificationCode: 'Please enter the verification code',
  sendVerificationCodeToEmail: 'Send code to email',
  codeTime: 'seconds later',
  SendVerificationCode: 'Send code',
  TheVerificationCodeHasBeenSent:
    'The verification code has been sent to the email, please check it',
  logInNow: 'Log In',
  noAccount: 'Haven’t registered yet? Register now!',
  register: 'register',
  warnInfo2: 'Please enter account and password!',
  warnInfo21: 'Login successful!',

  // 注册页面
  accountRegistration: 'Account Registration',
  confirmPassword: 'Confirm Password',
  pleaseReenterTheLoginPassword: 'Please re-enter the login password',
  fullName: 'Full name',
  PleaseEnterTheTeamName: 'Team information',
  // dateOfBirth: "date of birth",
  // schoolName: "School Name",
  // studentID: "Student ID",
  registerNow: 'Register Now',
  backLoginText: 'Back to login',
  existingAccount: 'Existing account? immediately',
  login: 'Login',
  warnInfo3:
    'The confirmation password is inconsistent with the setting password!',
  warnInfo8: 'Please enter the correct format email',
  warnInfo9: 'The verification code is only six digits',
  warnInfo10: ' Resend after seconds',
  warnInfo11: 'Minimum two members to participate',
  warnInfo16: 'Please upload student ID',
  warnInfo17: 'Please complete the player information',
  warnInfo18: 'There can only be four members at most',
  warnInfo19: 'Please enter complete team member information',
  warnInfo20: 'There are only four members at most',

  // 个人中心-账号信息
  accountEmail: 'Account email',
  captain: 'Team leader',
  member: 'Team member',
  pleaseEnterTheCaptainName: "Please enter the captain's name",
  pleaseEnterAMember: 'Please enter a member',
  PleaseEnterTheDateOfBirth: 'Please enter DOB',
  PleaseEnterSelectBirthDay: 'Please select DOB',
  pleaseEnterTheSchoolName: 'Please enter school name',
  pleaseEnterTheStudentId: 'Please enter student ID',
  pleaseEnterEmail: 'Please enter an email address',
  pleaseEnterEmailInfo: 'Please enter email',
  pleaseEnterYourName: 'Please enter full name',
  pleaseUploadYourCampusCard: 'Please upload your Campus card',
  warnInfo4: 'Registration is closed!',
  warnInfo5: 'exit successfully!',
  warnInfo12: 'Successfully modified',
  warnInfo13: 'Fail to edit',
  warnInfo14: 'Please enter the correct team name',
  warnInfo15: 'Please upload pictures',

  // 个人信息-修改个人信息-弹窗
  changePassword: 'Change password',
  enterOldPassword: 'Enter old password',
  pleaseEnterYourOldPassword: 'Please enter your old password',
  enterANewPassword: 'Enter a new password',
  pleaseEnterANewPassword: 'Please enter a new password',
  confirmPasswordAgain: 'Confirm Password',
  pleaseConfirmTheNewPassword: 'Please confirm the new password',
  passwordInfo:
    '*The password must be at least 16 characters long and contain large, Minuscule letters and numbers',
  cancellation: 'cancellation',
  confirmModification: 'Confirm modification',
  passwordWarnText: 'Password length must be at least 6 digits',

  // 关于我们
  yiliPublicWelfareFoundation: 'Elion Foundation',
  yiliPublicWelfareFoundationInfo:
    'Elion Foundation is a registered non-profit charity organization in Hong Kong since 2017 initiated by Elion International Investment Co., Ltd. We focus on promoting environmental protection and the development of new technology solutions in international and domestic ecological governance. Our commitment lies in fostering sustainable development, particularly in countries along the "Belt and Road" initiative.',
  DesertificationEnvironmentDiffusion: 'Spread of Desertification Awareness',
  PromoteEcologicalGovernanceEducation: 'Promote Ecological Control Education',
  InheritingGreenEnvironmental:
    'Advocate Environmental Protection through events',
  passActiveInfoOne: 'The 8th Kubuqi International Desert Forum',
  passActiveInfoTwo: 'Hong Kong Green Finance Sub Forum 2021',
  passActiveInfoThree:
    'On September 28, 2021, Elion Foundation and Friends of the Earth of Hong Kong jointly organized the Hong Kong Green Finance Sub Forum of the 8th Kubuqi International Desert Forum. Carbon peaking and carbon neutrality We invite over 80 green finance experts and professionals to jointly build a community of human and natural life. Among them, there are many top experts, scholars and industry leaders in the green finance industry in Hong Kong and mainland China, including Professor Ma Jun, chairman of the Hong Kong Green Finance Association, Mr. Eric Salheim, Deputy Secretary General of the United Nations and Executive Director of the United Nations Environment Programme, Jia Feng, current director of the Publicity and Education Center of the Ministry of Ecological Environment, and others. Everyone gathered here to discuss how Hong Kong, as an international financial center, can guide capital construction of a Low-carbon economy to achieve carbon neutrality, and put forward many valuable opinions and suggestions on the development of green finance in Hong Kong.',
  passActiveInfoFour:
    'The Yili Public Welfare Foundation believes that green finance is a key tool to alleviate global warming. This can enable Hong Kong to seize the opportunities of the Greater Bay Area and achieve carbon neutrality by 2050, becoming a green financial center in the Asia Pacific region.',
  treelionFoundation:
    'The Treelion Foundation incubated by Elion International Investment Co., Ltd. was officially registered in Singapore in 2019 and is one of the largest green ecological funds in the world. The foundation aims to build a sustainable development and low-carbon green digital economy platform based on blockchain technology.',
  contactInformation: 'Contact information',
  eleEmail: 'Email',
  // DesertForumTitle: "The 8th Kubuqi International Desert Forum",
  // HongKongGreenFinanceSubForumTitle: "Hong Kong Green Finance Sub Forum 2021",
  The8thKubuqiInternationalDesertForumin2021:
    'The 8th Kubuqi International Desert Forum in 2021',

  DesertForumInfo: `<p>Carbon Peak. Carbon Neutrality-Building a Community of Human and Natural Life
  </p><p>Over 80 prominent global experts and industry leaders in the field of green finance attended the event, lending their expertise to Hong Kong's efforts to capitalize on opportunities in the Greater Bay Area, achieve carbon neutrality by 2050, and establish itself as a leading green financial center in the Asia-Pacific region.
  </p>`,
  briefItemInfo1:
    'Green ecology Center on desertification and ecological protection. Focus on resolving issues in land, air, soil and biological pollution to promote ecological civilization construction',
  briefItemInfo2:
    'Green assets Forge sustainable and green business pattern by combining ecology, finance and internet, aiming to build the largest green digital data ecosystem',
  briefItemInfo3:
    'Green data Use blockchain technology to record data on global environment and biological diversity. Build big data platform of global ecology',
  briefItemInfo4:
    'Green cooperation Promote green cooperation in among international, regional, national and local levels. Create development opportunities for sharing and establishing ecological civilization',
  CochairsoftheGlobalSteeringCommittee:
    'Co-Chair of the Steering Committee of Treelion Foundation',
  FormerExecutiveDirectorofUNEP: 'Former Executive Director of UNEP',
  FormerDeputySecretaryGeneraloftheUnitedNations:
    'Former Deputy Secretary General of the United Nations',
  FormerExecutiveDirectoroftheUnitedNationsEnvironmentProgramme:
    'Former Chairman of the Development Assistance Committee of the United Nations Organization for Economic Cooperation and Development',
  FormerNorwayMinisterofEnvironmentandInternationalDevelopment:
    'Former Norway Minister of Environment and International Development',
  ChiefExecutiveOfficerandDirectors:
    'Council Secretary of Treelion Foundation Council',
  ChairmanoftheBoardofDirectorsofFriends:
    'Chairman of Friends of the Earth (HK)',
  MemberoftheInvestmentCommitteeInfo1: 'Africa Wildlife Foundation Consultant',
  MemberoftheInvestmentCommitteeInfo2:
    'Member of the Environmental Advisory Committee of the HKSAR Government',
  InvestmentCommitteeoftheHKSARGovernmentScholarshipFund:
    'Investment Committee of the HKSAR Government Scholarship Fund',
  MemberofSelffinancingPostsecondaryEducationFundInvestmentCommitteeoftheHKSARGovernment:
    'Member of Self-financing Post-secondary Education Fund Investment Committee of the HKSAR Government',
  MrErikSolheim: 'Mr Erik Solheim',
  MrPlatoKTYip: 'Mr Plato Yip',

  // 历届比赛花絮
  previousShortFilms: 'Short video introducing previous competitions',
  previousShortFilmsTips: 'Video promotional video for the first competition',
  previousPhotos: 'Photos of previous competitions',
  previousVisits: 'Visits to previous competitions',
  previousVisitsName1:
    'From the imagined desert to the oasis in front of us - The Kubuqi Journey of the Xiangjiang Student',

  // 大赛背景
  countdown:
    'Countdown to the registration deadline for the Kubuqi competition',
  deadline: 'Competition registration deadline',
  dateOfPublication: 'date of publication',
  year: 'year',
  month: 'month',
  sun: 'day',
  day: 'day',
  KBQbackgroundOfTheCompetition: 'Kubuqi Model',
  KBQbackgroundOfTheCompetitionInfo: `
  <p>Due to global climate and environmental changes, over <span class="highlight">250 million</span> of the population is directly affected by land desertification. The living conditions of <span class="highlight">1 billion</span> people in over <span class="highlight">100 countries</span> are now endangered. Around <span class="highlight">2 billion</span> people worldwide depend on the ecosystems of arid regions, with <span class="highlight">90%</span> of them living in developing countries. Countries involved in the "Belt and Road" initiative are among the main areas severely affected by desertification.</p >
<p>The Kubuqi Desert is the <span class="highlight">7th largest</span> desert in China, spanning <span class="highlight">18,600 km2</span> in Ordos, Inner Mongolia. It is the closest desert to Beijing, once an endless barren land and the source of sandstorms haunting Beijing. After <span class="highlight">35 years</span> of desert control effort, <span class="highlight">1/3</span> of the desert has turned into a self-sustaining oasis, with biodiversity restored and neighbouring communities revitalized. Now, the Kubuqi Model transformation is supported by revenue from photovoltaic energy generation, organic farming, eco-tourism, and more. The <span class="highlight">35-year</span> work in desert control has created the internationally acclaimed "Kubuqi Model" recognized by the United Nations.</p >
 `,
  KBQawards: `<p><span class="highlight">The Second Kubuqi Award: International Desert Sustainable Development Proposal Competition</span> & <span class="highlight">“Speak Sustainability” Secondary School Short Video Contest</span> aims to advocate global and national sustainable development and ecological conservation among the students, encourage students to look into the national status and contribute to the environmental governance of the “Belt and Road” Initiative.</p>
  </br><p>University participants can demonstrate their knowledge of innovative technologies and collaboratively express ideas for sustainable solutions from different study backgrounds or universities. Secondary school participants will create short videos to demonstrate their knowledge and thoughts on environmental and sustainable development issues.</p>`,
  target: 'The Kubuqi Award Supports UN SDGs',
  targetInterpretation:
    'The Kubuqi Competition fully promotes the 17 Sustainable Development Goals (SDGs) of the United Nations, focusing on Goal 4 (education), Goal 13 (climate action) and Goal 17 (cooperation to achieve the goals). The theme of this competition focuses on sustainable development of deserts, and fully considers the current and future development timelines. Student entries will have the opportunity to cover more goals, thereby further promoting the achievement of these goals.',
  targetInterpretation1: `The SDGs are built upon the three pillars of sustainable development: economic growth, environmental protection, and social progress. The goal is to promote economic development while also safeguarding the planet's environment and reducing inequality, ultimately creating a more prosperous, healthy, inclusive, and sustainable world. In response to the United Nations' established targets, these efforts aim to foster collective action for sustainable development within society. For a better understanding of the UN's 17 Sustainable Development Goals and detailed guidelines, you can refer to the<a href="https://sdgs.un.org/zh" target="_blank" rel="noopener noreferrer">official SDG website</a>.`,
  contestTheme: 'Competition Group',
  topicIntroduction: 'Theme Introduction',
  contestMode: 'Mode of Competition',
  YouthSustainableDevelopmentEducation:
    'Youth’s Education for Sustainable Development',
  YouthInfoOne:
    'Ensure Hong Kong students acquire the knowledge and skills needed to promote sustainable development and environmental protection',
  YouthInfoTwo:
    'Encourage <b>interdisciplinary critical thinking</b> and problem-solving and <b>practical application of knowledge</b>',
  YouthInfoThree:
    '<b>Offer opportunities</b> of expert mentorship and field learning experience',
  YouthInfoFour:
    '<b>Cultivate future leaders</b> for environmental protection and sustainable development',
  YouthInfofive:
    '<b>Promote global citizenship</b> and appreciation of cultural diversity and of culture’s contribution to sustainable development',
  ClimateEducationTheme: 'Climate Education Themes',
  ImprovingEducation:
    'Improve Education, Awareness, and Capacity on Climate Change Mitigation',
  ImprovingEducationInfoOne:
    'Raise awareness about the importance of taking climate action',
  ImprovingEducationInfoTwo:
    'Spark interest among younger generation in environmental protection',
  // PartnershipAchieveGoals: "Partnership to achieve goals",
  // PartnershipAchieveGoalsInfo:
  //   "By seeking sponsorship and cooperation to support the Kubuqi Prize initiative and combat desertification, mobilizing resources to have a greater impact on sustainable development",

  // 大赛主题
  // topicIntroductionText: `To encourage young people in Hong Kong and even internationally to pay attention to global climate and environmental issues, and to reflect on global and national desert governance and sustainable development, The second "Kubuqi Award": The "Talk about Sustainability" Short Film Competition for Middle School Students enables Hong Kong middle school students to understand the important role of sustainable development in ecologically fragile areas by shooting short films, so as to raise public attention to global climate and environmental issues and respond to the global Sustainable Development Goals.`,
  topicIntroductionText: `In order to encourage Hong Kong and international young people to pay attention to global climate and environmental issues, think about global and national desert governance and sustainable development, the second “Kubuqi Award”: “Speak Sustainability” Secondary School Short Video Contest will be open to all university and higher education students in Hong Kong. `,
  // topicIntroductionCollegeText:
  //   "In order to encourage Hong Kong and international young people to pay attention to global climate and environmental issues, think about global and national desert governance and sustainable Sustainable development, the second 'Kubqi Award': the International Desert Sustainable Development Competition will be open to all university and college students in Hong Kong. Let students develop their ideas, demonstrate their understanding of international cutting-edge technologies and the conception of sustainable solutions, and propose innovative and feasible solutions The sustainable development plan of the desert to promote the solution to the current land desertification problem and respond to the global carbon neutral policy goal.",
  topicIntroductionCollegeText:
    'In order to encourage Hong Kong and international young people to pay attention to global climate and environmental issues, think about global and national desert governance and sustainable development, the second “Kubuqi Award”: International Desert Sustainable Development Proposal Competition will be open to all university and higher education students in Hong Kong. ',

  // --中学组
  // MStopicListText:
  //   "Students are required to create a promotional video on environmental sustainability that includes one of the themes:",
  MStopicListText: `<p>Secondary school participants will film a short video to demonstrate their knowledge and thoughts on environmental and sustainable development issues through the process of creating short videos. <span class="bolderer">Videos are of the following themes:</span> </p>`,
  MStopicitem1: 'Energy & Climate Change',
  MStopicitem2: 'Atmospheric Pollution & Air Quality',
  MStopicitem3: 'Water Resources & Conservation',
  MStopicitem4: 'Biodiversity & Nature Conservation',
  // --大专组及大学组
  JCtopicListText: `<p>
    Targeting tertiary students, participants can demonstrate their knowledge of innovative technologies and collaboratively express ideas for sustainable solutions from point of views of different study background or universities. <span class="bolderer"> Proposals are of the following themes: </span> </p>`,
  // JCtopicListText:
  //   "The competition proposal can be based on one of the following four themes:",
  JCtopicitem1: 'Zero Carbon New Town Design',
  JCtopicitem1Info: `How to use modern technology and advanced architectural design concepts to achieve energy conservation and emission reduction in desert cities? Efficient utilize desert resources, while creating a humanized, healthy and comfortable living environment, and improving urban ecological value and living quality.`,
  JCtopicitem2: 'Desert Ecotourism Business',
  JCtopicitem2Info:
    'How to use desert resources and culture to provide tourists with a unique tourism experience in desert areas, while protecting the desert ecological environment and improving the economic development of local communities, and revitalizing desert tourism?',
  JCtopicitem3: 'Sustainable Utilization of Desert Energy and Water Resources',
  JCtopicitem3Info:
    'How renewable energy sources such as solar and wind power can be harnessed, and water resources such as rainwater and groundwater collected, stored and used to increase productivity and economic development in desert regions?',
  JCtopicitem4: 'Desert Ecosystem Conservation and Restoration',
  JCtopicitem4Info:
    'How to protect vegetation and wildlife in ecologically fragile deserts, establish desert sanctuaries and restore ecosystems, and promote sustainable land management and agricultural practices?',

  // 大赛模式
  // 中学
  JCcontestModeitem1: 'venue',
  JCcontestModeitemInfo: 'Hong Kong (Online)',
  JCcontestModeitem2: 'Eligibility',
  JCcontestModeitem2Info:
    'Any student studying in secondary school in Hong Kong',
  JCcontestModeitem3: 'Teaming',
  // JCcontestModeitem3Info:
  //   "Teams of 2-4 people can form their own teams to participate, and members can come from different schools and grades",
  JCcontestModeitem3Info: `
  <p>Teams can be formed within the school, each team consists of 2-4 members.</p>
  <p>Each team require a nomination by a school teacher, each school can have more than one team participating.</p>`,

  JCcontestModeitem4: 'Submission Format',
  JCcontestModeitem4Info: '1.5 minute video; uploaded in MP4 format',
  JCcontestModeitem5: 'Language of Submission',
  JCcontestModeitem5Info: `After the contestants upload their preliminary works, the judges will conduct an online review. 15 teams from the finalists will be uploaded to the competition's official website and receive public likes. The final total score will be determined by the sum of the jury's rating and the public's rating.`,
  JCcontestModeitem6: 'Mode of Competition',
  // JCcontestModeitem6Info:
  //   "After the contestants submit their short films, the judging panel will score and select 15 final works, together with the public vote to get the final result.",
  JCcontestModeitem6Info:
    'After the contestants submit their short videos, the judging panel will score and select 15 final works, followed by public voting.',

  // 大专
  JCcontestModeitem1: 'Venue',
  JCcontestModeitem1Info: 'Hong Kong (Online + Offline)',
  JCcontestModeitem2: 'Eligibility',
  JCcontestModeitem21Info:
    'All universities and tertiary institutions students in Hong Kong, including UGC funded universities, self funded institutions, post secondary colleges, and private universities',
  // JCcontestModeitem2Info: "Hong Kong middle school students",
  JCcontestModeitem31: 'Teaming',
  JCcontestModeitem31Info:
    'Teams can be formed within or between institutes and faculties, each team will consists of 2-4 members. Each participant can only register in one group.',
  JCcontestModeitem41: 'Submission Format',
  // JCcontestModeitem4Info: 'Plan; Submit in PDF format',
  JCcontestModeitem41Info: 'Proposal in PDF format',
  // JCcontestModeitem5: "Language of the work",
  JCcontestModeitem5: 'Language of Submission',
  // JCcontestModeitem5: "Competition format",
  JCcontestModeitem5Info: 'Cantonese, English, or Mandarin',
  // JCcontestModeitem6: 'Maximum number of entries',
  JCcontestModeitem61: 'Work specifications',
  JCcontestModeitem61Info: `<p>First-round submission: at least 2 pages, including text/ illustrations/ tables; effectively express the concept of the plan; </p>
  <p>Final submission: about 5 pages, including complete implementation plan, financial calculation, proposal layout design (optional)</p>`,
  JCcontestModeitem7: 'Mode of Competition',
  JCcontestModeitem7Info: `
  <p>Participants will upload their proposals online for the preliminary round judging online; final judging will take place in person for work display and Q&A section, judging panel will score on the spot.</p>`,
  // JCcontestModeitem7Info: `<p>After the contestants upload their preliminary works, the judges will conduct online judging and select the final team；</p><p>The teams nominated for the finals will receive expert training and modify and refine their works；
  // </p><p>After submitting the final work, the team will participate in the offline work display and defense, and the jury will score on-site；</p><p>The winning team will be announced before the award ceremony.</p>`,
  JCcontestModeitem8: 'Entry number',
  JCcontestModeitem8Info: 'Unlimited',
  // JCcontestModeitem8Info: `<p>After the contestants upload their preliminary works, the judges will conduct online judging and select the final team；</p><p>The teams nominated for the finals will receive expert training and modify and refine their works；
  // </p><p>After submitting the final work, the team will participate in the offline work display and defense, and the jury will score on-site；</p><p>The winning team will be announced before the award ceremony.</p>`,
  JCcontestModeitem9: 'Word Limit',
  JCcontestModeitem9Info: 'Within 3,000 Chinese words or 3,500 English words',

  // 大学国际组
  UcontestModeitem1: 'venue',
  judgeDay: 'Judging Day',
  judgeDayInfo: `
  <p>-Venue: Fairmont House, 8 Cotton Tree Dr, Central  </p>
  <p>-Date: 11 April 2024</p>
  <p>-Time: TBC</p>`,
  UcontestModeitem1Info: 'Online',
  UcontestModeitem2: 'Participants',
  UcontestModeitem2Info:
    'Full-time undergraduates and postgraduates studying in any universities around the world',
  UcontestModeitem3: 'Team formation form',
  UcontestModeitem3Info:
    'Teams can be formed within or between institutes and faculties, each team will consists of 2-4 members. Each participant can only register in one group.',
  UcontestModeitem4: 'Work form',
  UcontestModeitem4Info: 'Proposal in PDF format',
  UcontestModeitem5: 'Entry quota',
  UcontestModeitem5Info: 'Cantonese, English, or Mandarin',
  UcontestModeitem6: 'Work specifications',
  UcontestModeitem6Info: `
  <p>First-round submission: at least 2 pages, including text/ illustrations/ tables; effectively express the concept of the plan;</p>
  <p>Final submission: Participants are required to submit a proposal and a presentation slide deck (to be used during the judging day presentation)</p>
  <p>1.1	Proposal </p>
  <p>&emsp;-Format: PDF file with complete proposal, financial projections, and technical design (optional).   </p>
  <p>&emsp;-Word limit: Minimum 2,000 Chinese words or 2,500 English words.</p>
  <p>&emsp;-Final submission deadline: 2 April 2024, 23:59.</p>
  <p>&emsp;-Late submission results in disqualification.  </p>
  <p>1.2  Presentation Slide Deck</p>
  <p>&emsp;-Format: PPT file, minimum of 5 slides.</p>
  <p>&emsp;-Final submission deadline: 7 April 2024, 23:59.</p>
  <p>&emsp;-No modifications allowed after submission.  </p>
  <p>&emsp;-Late submission results in disqualification.</p>
  <p>&emsp;-Teams should have a backup presentation slide deck for unforeseen circumstances.</p>
  `,
  UcontestModeitem7Info: `
  <p>The preliminary round will be judged online, and the participants only need to upload their works; the final will be an online presentation with Q&A section, and the judging panel will score online</p>
  <p>All team members must register 10 minutes prior to presentation.</p>
  <p>Disqualification if less than half of team arrives on time.</p>
  <p>Each presentation lasts 15 minutes.</p>
  <p>5-minute Q&A session with judges after presentation.</p>
  <p>Final results announce on 20 April 2024.</p>
  `,
  judgCriteria: 'Judging Criteria',
  judgCriteriaInfo: `
  <p>Total score out of 100: Proposal accounts for 75%, On-site presentation accounts for 25%.</p>
  <p>1.1 Proposal (75%): Factors of Environmental Protection (25%), Innovation & Originality (25%), Benefits & Feasibility (25%)</p>
  <p>2.2 On-site Presentation (25%): Presentation Skill (5%), Effectiveness of PPT Presentation (5%), Quality of Q&A Responses (5%), Attendance of the Team (5%), Time Management (5%)</p>
  <p>The judging panel will assess all final teams based on the above criteria, and the top three teams with the highest scores will be awarded first, second, and third places.</p>`,
  // UcontestModeitem7Info: `
  // <p>After the contestants upload their preliminary works, the judges will conduct an online review and select the final team;</p>
  // <p>The teams nominated for the finals will receive expert training and modify and refine their works;</p>
  // <p>After submitting the final work, the team will participate in the online exhibition and defense of the work, and the jury will conduct on-site evaluations;</p>
  // <p>The winning team will be announced before the award ceremony.</p>`,
  UcontestModeitem8Info:
    'Limited to 500 groups (registration shall be made according to the order of registration)',

  // 往届参赛列表
  talkAboutDesertificationShortFilmCompetition: `"Talk about Desertification" Short Film Competition`,
  publicToLikeAwards: `Most Liked Video`,
  desertGovernanceEntrepreneurshipCompetition:
    'Kubuqi Desert Control Business Plan Competition',
  christianAndMissionaryAllianceSunKeiSecondarySchool:
    'Christian and Missionary Alliance Sun Kei Secondary School',
  surprisinglyDesolate: `“Dead"sert`,
  CCCFongYunWahSecondarySchool: 'CCC Fong Yun Wah Secondary School',
  TheMindOftheSandElf: 'The Voice of the Sand Spirit',
  TheMindOftheSandElf1: 'Desertification of LEGO City',
  MingChiCollegeOftheChineseChristianChurch: 'CCC Ming Kei College',
  unbalance: 'Imbalance',
  HumanitySinicization: 'Linkage between human and desertification',
  CheungChukShanCollege: 'Cheung Chuk Shan College',
  LEGOCityDesolationAndLocalization: 'Desertification of LEGO City',
  DesolateLandAndFragrantLand: 'Dystopia-Utopia',
  MissionaryAssociationChenZhuSuhuaMemorialHighSchool:
    'Christian Alliance S W Chan Memorial College',
  Youthtroubles: 'Troubles',
  DiocesanGirlsSchool: "Diocesan Girls' School",
  WildernessHair: 'Barren Hair',
  ELCHKLutheranSecondarySchool: 'ELCHK Lutheran Secondary School',
  DesertificationIssues: 'Problems of Desertification',
  HongKongRedSwastikaSocietyTaiPoSwastikaSecondarySchool:
    'Hong Kong Red Swastika Society Tai Po Secondary School',
  TwoMinutesToUnderstandTheChineseCultureOfTheWilderness:
    'Desertification in 2 minutes',
  HongKongFabricManufacturersAssociationZhuShilinSecondarySchool:
    'HKWMA Chu Shek Lun Secondary School',
  HowSeriousIsDesertification: 'How serious of desertification is?',
  LaSalleCollege: 'La Salle College',
  DesertEncyclopedia: 'Desertipedia',
  champion: 'Champion',
  TopTwentyFinalists: 'Top 20',
  otherWorks: 'other entries',
  MunsangCollegeHongKongIsland: 'Munsang College (H.K Island)',
  TheCulpritOfDesertification: 'RESPONSES to Desertification',
  PoLeungKukRocheFoundationMiddleSchool: 'Po Leung Kuk Laws Foundation College',
  WhenTheEarthEncountersDesertification: 'When the earth meets desertification',
  EpiscopalLamChoMouSecondarySchool: 'S.K.H Lam Kau Mow Secondary School',
  GlobalWildernessGettoKnowIt:
    'Brief look into Desertification: From cause to solution',
  EpiscopalWhiteJohnChurchHighSchool: 'SKH Bishop Baker Secondary School',
  EarthPartyTalkingAboutWasteCake: 'Cake of des(s)ert',
  runnerUp: '2nd Prize',
  TrueLightGirlsCollege: "True Light Girls' College",
  DoNotWasteZhang: "Please Don't Expand",
  TungWahGroupOfHospitalsKapYanDirectorsCollege:
    "TWGHs Kap Yan Directors' College",
  CryingEarth: 'The earth without tears',
  TungWahGroupOfHospitalsQiuZitianMemorialMiddleSchool:
    'TWGHs Yau Tze Tin Memorial College',
  TheStrangeSoldierOfWildernessAndBirthday: 'The Warriors',
  ThirdPlaceRunnerUp: '3rd Prize',
  EnpingChamberofCommerceandIndustryLiLinmingMiddleSchool:
    'YPICA Lee Lim Ming College',
  EsportsSandPreventionStrategy: 'DCM Magic Weapon Strategy',
  ActivelyParticipatingInSchoolAwards: 'Most Active Participation Award',
  CONSTRUCTINGOUTDESERTOPIAKUBUQI: 'CONSTRUCTING OUR DESERTOPIA | KUBUQI',
  HongKongUniversityOfScienceAndTechnology: 'HKUST',
  UtilizinggeneticallyengineeredmicrobialcocktailstotackledesertificationintheKubuqidesert:
    'Utilizing genetically-engineered microbial cocktails to tackle desertification in the Kubuqi desert',
  OtherWorks: 'Other works',
  CityUniversityOfHongKong: 'CityU',
  IoTKubuqiAnEcommercePlatformBringingTheWorldCloserToKubuqi:
    'IoT Kubuqi - A E-commerce Platform to bring the World to Kubuqi',
  HongKongBaptistUniversity: 'HKBU',
  TheKubuqiAwardDesertificationControlBusinessPlanCompetition:
    'The Kubuqi Award Desertification Control Business Plan Competition',
  Universities: 'EdU, CUHK, CityU, HKU',
  TheArtCapitalofKubuqi: 'Kubuqi Art Hub',
  TheChineseUniversityofHongKong: 'CUHK',
  KubuqiEnvironmentalProtectionTown: 'Kubuqi Eco-Friendly Town',
  CityUniversities: 'CityU, CUHK, HKU',
  TheKubuqiAwardDesertificationControlBusinessPlan:
    'The Kubuqi Award - Desertification Control Business Plan',
  TheUniversityofHongKong: 'HKU',
  MemoryForest: 'Memory Forest',
  LingnanSchoolinHongKong: 'LingU',
  DesertificationDesertControlLaw: 'Desertification - Desert Control Solutions',
  UniversitiesThree: 'CUHK, HKU, HKUST',
  KubuqiDesertControlBusinessPlanAquaponics:
    'Kubuqi Desert Control Business Plan - Aquaponics',
  KubuqiDesertProvidingYouWithAnInternationalAcademicExchangePlatformforEcologicalEnvironment:
    'Kubuqi Desert - An international academic exchange platform for ecological environment',
  UniversitiesFour: 'CUHK, HKKU',
  EcoSenseTianyouHeyi: 'EcoSense',
  schoolInfoOne: 'HKU, PolyU, THEi',
  schoolInfoTwo: 'HKU, HKBU',
  workName1: 'Happy and Harmonious Camels',

  // 首页-大赛时间表
  MiddleSchoolGroupCompetitionProcess:
    'Middle School Group Competition Process',
  UniversityGroupCompetitionProcess: 'University Group Competition Process',

  // 上传提示
  uploadTypeTips: 'Uploading files can only be in PDF、PPT、MP4 format!',

  // 第二届库布其 短片投票
  secondTitle: 'The 2nd Kubuqi Award',
  workDetail: 'Work details',
  vote: 'Vote now',
  voted: 'Voted',
  share: 'Share',
  votingTime: 'Voting Time：',
  hintTimeError: 'Please vote within the specified time',
  copyUrl: 'Copy Link',
  saveQRCode: 'Save QRCode',
  judgesNameOne: 'Prof. Amos P. K. Tai',
  judgesNameOneP1:
    'Associate Professor, Earth and Environmental Sciences Program, Faculty of Science',
  judgesNameOneP2:
    'Director, Earth System Science Programme, Faculty of Science',
  judgesNameOneP3: 'Associate Director, Office of University General Education',
  judgesNameOneP4:
    'Associate Director, Institute of Environment, Energy and Sustainability The Chinese University of Hong Kong',
  judgesNameTwo: 'Dr. Caroline Law',
  judgesNameTwoP1: 'Founder, Nature In situ Limited',
  judgesNameThree: 'Mr. Ken Ngai',
  judgesNameThreeP1: 'Executive Director, Hong Kong Education City (EdCity)',
  judgesNameFour: 'Dr. Anthony Kong',
  judgesNameFourP1:
    'Deputy Programme Leader, MSc Multimedia and Entertainment Technology, School of Design',
  judgesNameFive: 'Mr. Cheng Kai Ming',
  judgesNameFiveP1: 'Former Head of Radio 1, RTHK',
  judgesNameSix: 'Mr. David Lo',
  judgesNameSixP1: 'Founder & Creative Director, LOMATTERS Creative Studio',
  judgesNameSixP2: 'Vice-Chairman, The Green Earth',
  judgesNameSixP3: 'Director, Hong Kong Design Centre',

  // 补充
  copyText: 'Link copied',
  voteSuccess: 'The vote was successful',
  reTryInfo: 'Verification code has been sent, please try again later',
  votedInfo: 'You have already voted',
  voteText: 'Ballot',
  // 大学组10强
  universityTopTitle:
    'Top 10 Finalists of the International Desert Sustainable Development Proposal Competition',
  universityTopText:
    'The long-awaited top 10 finalists of the International Desert Sustainable Development Proposal Competition have been announced🎉! Friendly reminder all the top 10 teams must complete the submission of the final entries and attend the following events of the second mentorship session and the judging day to retain eligibility. The committee hereby reserves the right to make final decisions, including change or disqualification of all competing teams at any time. We highly appreciate the participation of all the competing teams, which have brought splendid entries that have added much vibrancy to the competition💚!Additionally, congratulations to the top 10 teams🥳. Later on, we will announce the details of the mentorship program🧑🏻‍💻. Everyone, please continue to follow @thekubuqiaward for more competition updates💪🏻!',
  finalistsTitle: 'Top 10 finalists (in no particular order):',
  talks:
    '#thekubuqiaward #environment #social #governance #invest #HK #hongkong #desert #kubuqidesert #college #university #school #competition',
  //
  placeholder1: 'Please enter the title of the work',
  placeholder2: 'Please select a registration topic',
  notice:
    '*Note: The upload attachment type is video,PDF,PPT; the file size does not exceed 2G',
  notice1: 'Click to upload work attachments',

  registrationTopic: 'Registration topic',
  uploaWork: 'Upload work attachments',
  theme1: 'Zero Carbon New Town Design',
  theme2: 'Desert Ecotourism Business',
  theme3: 'Sustainable Utilization of Desert Energy and Water Resources',
  theme4: 'Desert Ecosystem Conservation and Restoration',

  // 第一届比赛花絮
  AwardWinnersList: 'Secondary School Group Winners List',
  workList: 'First Kubuqi Contest - Award-Winning Entries',
  collegeContest:
    'College Students - Desertification Control Entrepreneurship Competition',
  middleContest:
    "High School Students - 'Discuss Desertification' Short Film Contest",
  workPriceList: `"Speak Sustainability" Secondary School Short Video Contest`,
  workPriceList1:
    'International Desert Sustainable Development Proposal Competition Winners List',
  side1: 'Competition Introduction',
  side2: 'Mentorship Program',
  side3: 'Awards Ceremony',
  side4: 'Kubuqi Desert Tour',
  side5: 'Post-Competition Gathering',
  side6: 'Collection of Works',
  side7: 'More Photos',
  brief1:
    'Three briefing sessions were held before the registration deadline for the competition. Students actively participated and the atmosphere was warm. The seminar was honored to invite Mr. Yau Ying-wah, CEO of Dragonair, and Mr. Ye Guangtao, director of Elion Charity Foundation, to share with students the tips for writing a plan and answer their questions about the competition.',
  brief2:
    'After fierce competition in the preliminary round, 14 outstanding teams successfully advanced to the final stage and received a rare opportunity to be personally mentored by experts in the financial industry. </br><div>The organizer of the competition specially invited experts from Barclays Bank PLC. to serve as tutors for the students to provide professional opinions and suggestions on the financial budget part of the business plan. The assistance of expert mentors significantly improved the quality and enrichment of all participating proposals.</div>',
  brief3:
    'The first Kubuqi Award Ceremony was hosted by Dr. Cai Ruolian, former Deputy Director of the Education Bureau. Li Lu, former director of the Education and Science Department of the Liaison Office of the Central Committee of the Communist Party of China, and Jiang Jianxiang, director of the Education and Science Department of the Liaison Office of the Central Committee of the Communist Party of China, also came to personally encourage the younger generation to continue to explore hard in the fields of science and environment and make positive contributions to regional and global environmental protection.',
  brief4:
    'The winning team went to the Kubuqi Desert for a field trip. </br>-Visit the Kubuqi Eco-Energy Photovoltaic Project </br>-Visit the high-tech seed bank and seedling greenhouse</br>-Visit Elion Oriental School</br>-Experience local food and folk culture at the homes of herdsmen</br> - Watch demonstrations of minimally invasive air flow tree planting and drone tree planting</br> - Plant saplings with your own hands',
  brief5:
    'After the competition was successfully concluded, the students turned enemies into friends and were invited to participate in the post-game dinner organized by the organizer. They chatted with each other during the dinner, shared their thoughts on the competition, and provided helpful suggestions for the next competition. At the same time, they also promised to be willing to provide help and support to future juniors and sisters at any time by sharing the valuable experience and knowledge they learned in the competition. This atmosphere of passing on the fire from generation to generation makes the significance of the competition even more profound. It not only allows students to grow professionally, but also cultivates team spirit and friendship.',
  timeline: [
    // 英文翻译
    {
      title: '2023/08/15—2023/10/31',
      content: 'Online Competition Registration'
    },
    {
      title: '2023/08/15—2023/11/05',
      content: 'Qualification Review'
    },
    {
      title: '2023/11/01—2023/12/01',
      content: 'Video Submission'
    },
    {
      title: '2023/11/05—2023/12/05',
      content: 'First Round Selection'
    },
    {
      title: '2023/12/05—2024/02/01',
      content: 'Jury Evaluation'
    },
    {
      title: '2024/02/01',
      content: 'Announcement of Top 15 Finalists'
    },
    {
      title: '2024/02/01—2024/03/01',
      content: 'Public Voting'
    },
    {
      title: '2024/04/01',
      content: 'Winners Announcement'
    },
    {
      title: 'TBD',
      content: 'Award Ceremony'
    },
    {
      title: 'Late June',
      content: 'Kubuqi Field Trip'
    }
  ],
  UniversityTimeline: [
    { time: '2023/10/03-2023/10/13', name: 'University Presentation' },
    { time: '2023/08/15-TBC', name: 'Online Competition Application' },
    { time: '2023/08/15-TBC', name: 'Qualification Check' },
    { time: '2023/11/20-2023/12/31', name: 'Preliminary Submission' },
    { time: '2023/11/20-2024/01/05', name: 'First Stage Screening' },
    { time: '2024/01/05-2024/02/08', name: 'Judging and Scoring' },
    { time: '2024/02/09', name: 'Announcement of 10 Finalists' },
    { time: '2024/02/20-2024/03/28', name: 'Expert Training' },
    { time: '2024/04/02', name: 'Final Submission' },
    { time: '2024/04/06-2024/04/13', name: 'University Group Judging Day' },
    { time: '2024/04/20', name: 'Announcement of Winners' },
    { time: 'TBD', name: 'Award Ceremony' },
    { time: 'Late June', name: 'Kubuqi Exploration' }
  ],
  judgesMiddlleSchoolContent: 'Middle School Group Judges',
  judgesUniversityContent: 'University Group Judges',
  judgesDetailText: 'Details',

  winnerTitle1: 'Earth guard Earth Guardians',
  winnerMenber1:
    'Team members: Qiu Zijing, Chen Aiqing, Wang Shuman, Liu Meiyi',
  winnerSchool1: 'School: FengCai School',

  winnerTitle2: 'Carbon world',
  winnerMenber2:
    'Team members: Luo Ruibin, Xiong Wenyi, Ma Xinlin, Yang Xiuqiao',
  winnerSchool2: 'School: Christian Church of China Kee Yuan Secondary School',

  winnerTitle3: 'TOAD Sustainable',
  winnerMenber3:
    'Team members: Luo Huiting, CAI Hohong, Sahin Daphne Eylul, Liang Yayi',
  winnerSchool3: 'School: Lam Tai Fai Secondary School',

  workWinnerText1: 'Champion: Energy and Climate Anomalies',
  workWinnerText2: '2nd Prize: The Earth is so Sick',
  workWinnerText:
    "3rd Prize: Why is the Earth's water resource repeatedly polluted? How should humans survive? The Earth Guardians have repeatedly strongly declared: Water! Please protect!",

  outstandingText: 'Outstanding',

  universityTitle1: 'Desert Prince',
  universityMenber1: 'Team members: Yang Qian, Wang Yihua',
  universityTitle2: 'Kubu "strange" tour',
  universityMenber2: 'Team members: He Xilin, Yang Xiaoling, He Haozhang',
  universityTitle3: 'Stan',
  universityMenber3:
    'Team members: Liao Ruopeng, Weng Mingming, Chen Jinglan, Tan Baili',

  pastGamesTitle1:
    'Control of Desertification in the Kubuqi Desert by Using genetically engineered Microbial Mixtures',
  pastGamesMenber1: 'Team member:Keira Lee Rice、Agnieszka Monika Lesniak',
  pastGamesSchool1: 'School: Hong Kong University of Science and Technology',
  pastGamesTitle2: 'Unite with the other side',
  pastGamesMenber2:
    'Team member:Weng Zixian, Yuan Yingqing, Li Jiamin, Zhang Xiaoting',
  pastGamesSchool2:
    'Schools: University of Hong Kong, Hong Kong Polytechnic University, Hong Kong Institute of Higher Education Technology',
  pastGamesTitle3: 'Luo Yirong',
  pastGamesMenber3:
    'Team member: Zhou Xitqing, Huang Hausen, Shi Shengyi, Xue Xuqi',
  pastGamesSchool3:
    'Schools: University of Hong Kong, Hong Kong Baptist University',

  pastGamesWorkTitle1: 'Champion: "Desertification\'s Evil"',
  pastGamesWorkSchool1: 'School: Hong Kong Island Civil Service College',
  pastGamesWorkMenber1:
    'Team member: Hung Ka Hin, Lam Ching Yin, So Ching To, Yip Ka Po',
  pastGamesWorkTitle2: '2nd Prize: "Please do not "Desertification" ',
  pastGamesWorkSchool2: "School: True Light Girls' College",
  pastGamesWorkMenber2:
    'Team member: Zhang Yinglan, Zhang Xuyue, Huang Jiushuang, Liang Jiahui',
  pastGamesWorkTitle3: '3rd Prize: "E-sports Anti-desertification Strategy"',
  pastGamesWorkSchool3: 'School: Lee Lim Ming Secondary School',
  pastGamesWorkMenber3: 'Team member: Mo Junhong, Li Haoxian',
  pastGamesWorkTitle4: 'Public to Like Award: "Desert"',
  pastGamesWorkSchool4: 'School: Christian Mission School',
  pastGamesWorkMenber4:
    'Team member: Jiang Zhuozi, Xiao Xianchong, Yang Cuixin, Wang Yinxixi',

  timeLineTest: 'Time Line',
  okText: 'Confirm',

  interestingSidelightsTitle: 'Kubuqi Competition Sidelights',
  periodTitle: '2nd',
  interestingSidelightsContent:
    'The first Kubuqi Award Ceremony was hosted by Dr. Cai Ruolian, former Deputy Director of the Education Bureau. Li Lu, former director of the Education and Science Department of the Liaison Office of the Central Committee of the Communist Party of China, and Jiang Jianxiang, director of the Education and Science Department of the Liaison Office of the Central Committee of the Communist Party of China, also came to personally encourage the younger generation to continue to explore hard in the fields of science and environment and make positive contributions to regional and global environmental protection.',
  interSide1: 'University Presentation',
  interSide2: 'Mentorship Day',
  interSide3: 'Judging Day',
  interSide4: 'Award Ceremony',
  interSide5: 'Kubuqi Desert Tour',
  interSide6: 'Winning Works',
  teachInText: `<span class="text_15"
              >&nbsp;&nbsp;&nbsp;&nbsp;This competition visited several universities in Hong Kong, including the Chinese University of Hong Kong, the Hong Kong University of Science and Technology, the Hong Kong Institute of Education, Lingnan University, Hong Kong Shue Yan University, City University of Hong Kong, the Hong Kong Institute of Vocational Education (Sha Tin) and the Hong Kong Polytechnic University. A series of lectures were held focusing on the current situation of climate change and the continuous deterioration of the ecological environment. The organizers, in collaboration with experts and scholars in the fields of environmental science and sustainable development, analyzed the severe challenges of global warming and the deep-seated impacts of ecological deterioration from an interdisciplinary perspective. The guests, based on their own research, vividly expounded on issues such as carbon neutrality paths, biodiversity conservation, and low-carbon city construction through cutting-edge data, regional cases, and innovative solutions. They also engaged in in-depth dialogues with students on local ecological policies in Hong Kong.</span
            >
            <p></p>
            <span class="text_16"
              >&nbsp;&nbsp;The lecture was designed with an interactive session to encourage students to express their views on "individual action and global responsibility". The atmosphere was lively. The event broke through the boundaries of thinking from multiple perspectives, deepening the students' understanding of environmental issues and inspiring them to embark on the mission of sustainable development, laying a solid theoretical foundation for subsequent sessions.</span
            >`,
  side4Text:
    'As a core enabling part of the competition schedule, Mentor Day invited a team of expert mentors from HSBC, Cyberport and MTR Corporation to provide one-on-one guidance to the ten finalist teams. Based on their diverse experiences in areas such as financial innovation, smart technology and sustainable development, the mentors offered insights into project feasibility analysis, business model optimization, technology application implementation and social impact expansion. Through case dissection, simulated pitches and group discussions, the teams made breakthrough improvements in data support, logical rigor and presentation. Some works even incorporated new ideas of cross-domain resource integration, helping student teams bridge the "last mile" between creativity and implementation, laying a solid foundation for the final competition.',
  side5Text:
    'After eight months of refinement from the initial idea generation, work iteration to meticulous polishing, the ten finalist teams reached the "moment of truth" on the final review day. At the final review site, the teams presented their proposals with both professional depth and narrative tension, showcasing their diverse explorations. Each work embodies the practical thinking of Hong Kong youth on environmental protection and sustainable development. The judging panel, composed of academic professors, industry leaders and investment professionals, remained fully engaged throughout, engaging in "sparkling" intellectual exchanges with the contestants during the Q&A session - on issues such as strategies to break through technical bottlenecks and the balance between commercial and social value, the judges posed sharp questions to prompt the teams to conduct more meticulous reasoning, while the contestants responded to the challenges with data-driven arguments and cross-disciplinary thinking, making the path of "theorizing to practice" increasingly clear. Dr. Hau Kwong Sze, JP, Director of the Environmental Protection Department of Hong Kong, was present as a special guest, interacting warmly with the students and offering valuable guidance.',
  side6Text:
    'As the grand finale of the event, the award ceremony invited several industry experts to provide authoritative recognition and profound expectations for this youth environmental innovation conference. They personally encouraged the younger generation to continuously strive and explore in the fields of science and environment, making positive contributions to regional and even global environmental protection.',
  side7Text:
    'The second "Ku Buqi Award" winning team, organized by the Hong Kong Yili Charity Foundation, ventured into the Kubuqi Desert in Inner Mongolia, embarking on a four-day, three-night field investigation of the desert. The students visited the Sun Valley Photovoltaic Hydro-Low Carbon Industrial Base to learn about the cutting-edge technologies for solar power desert control and ecological restoration; they entered the Sand Xerophytic Shrub Germplasm Center to witness how technology can bring vitality to the desert; and they interacted with local residents in the New Village of Sheji Lake, experiencing the sustainable model of "desert control and wealth creation". Through hands-on activities such as planting grass grids to stabilize the sand, communicating with desert students, and experiencing a green agricultural lifestyle, the Hong Kong teenagers deeply understood the hardships and wisdom of ecological governance. This immersive study tour, from the perspective of "Green Development under the Belt and Road Initiative", transformed the concept of low-carbon into a belief for action, allowing the green seeds of Kubuqi to take root and sprout in the hearts of the young.',
  workTitle2: 'Second Kubuqi Award - Winning Works',
  photograph: 'Photograph',
  photoWall:'Photo Wall',
  sustainableMentext:'Middle School - "Discuss Sustainability" Short Film Contest',
  sustainableMentext2:'University - International Desert Sustainable Development Competition',
}
